import { initialState } from "./state"

// ---------------------------------------------------------------------------
// Generic dataset mutation
// ---------------------------------------------------------------------------

export const setDatasetStat = (state, { dataset, value }) => {
  if (!state.datasets[dataset] && dataset !== "primary" && dataset !== "comparison") return
  state.datasets[dataset] = value
}

// ---------------------------------------------------------------------------
// Params
// ---------------------------------------------------------------------------

export const setParams = (state, payload) => {
  state.params = payload
}

export const setComparisonParams = (state, payload) => {
  state.comparisonParams = payload
}

// ---------------------------------------------------------------------------
// Comparison mode
// ---------------------------------------------------------------------------

export const setComparisonMode = (state, payload) => {
  state.isComparisonMode = payload
}

// ---------------------------------------------------------------------------
// Selected podcasts
// ---------------------------------------------------------------------------

export const setSelectedPodcasts = (state, payload) => {
  state.selectedPodcasts = payload
}

// ---------------------------------------------------------------------------
// Reset
// ---------------------------------------------------------------------------

export const reset = (state) => {
  const s = initialState()
  Object.keys(s).forEach((key) => {
    state[key] = s[key]
  })
}
